module.exports = __webpack_public_path__ + "img/Balance-inspect-medium.a51f170a.jpg";